var map = {
	"./aoty-da-DK.svg": 2585,
	"./aoty-de-DE.svg": 8728,
	"./aoty-en-GB.svg": 14873,
	"./aoty-en-US.svg": 10704,
	"./aoty-es-ES.svg": 78628,
	"./aoty-es-MX.svg": 25958,
	"./aoty-fr-FR.svg": 68789,
	"./aoty-it-IT.svg": 98344,
	"./aoty-nb-NO.svg": 7810,
	"./aoty-nl-NL.svg": 6586,
	"./aoty-pl-PL.svg": 7458,
	"./aoty-pt-BR.svg": 36635,
	"./aoty-pt-PT.svg": 51668,
	"./aoty-sv-SE.svg": 46692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96597;